export function formatNumberWithIntl(number) {
	const parts = number.toString().split('.')
	parts[0] = new Intl.NumberFormat('en-US', { useGrouping: true })
		.format(parts[0])
		.replace(/,/g, ' ')
	return parts.join('.')
}
